import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
// routes
import { useParams } from 'src/routes/hooks';
import { JobDetailsView } from 'src/sections/job2/view';
// sections

// ----------------------------------------------------------------------

export default function JobDetailsPage() {
  // router
  const params = useParams();
  const { id } = params;

  // states
  const [role, setTitleRole] = useState('');

  return (
    <>
      <Helmet>
        <title> Hireintel - {role || 'Candidates'} </title>
      </Helmet>

      <JobDetailsView setTitleRole={setTitleRole} jobId={id} />
    </>
  );
}
